var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsistaChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 24.1894H12.6484H12.0658C9.33614 24.1894 6.60646 23.2441 4.39829 21.3536C4.13198 21.1285 3.88231 20.8978 3.6382 20.6503C2.67282 19.6712 1.91272 18.574 1.35236 17.3925C-0.822515 12.8855 -0.0624187 7.28707 3.6382 3.53975C7.33326 -0.207567 12.8481 -0.978412 17.2977 1.22159C18.4629 1.78988 19.5447 2.56635 20.5101 3.53975C20.7542 3.78732 20.9873 4.04615 21.2036 4.3106C23.0734 6.54999 24.0054 9.31828 23.9999 12.0866V12.6661V12.6717V24.1894Z",
    fill: "#4FC6E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.292 1.22159L1.34661 17.3925C-0.822716 12.8855 -0.0626196 7.28707 3.638 3.53975C7.32752 -0.207566 12.8479 -0.978412 17.292 1.22159Z",
    fill: "#E34A4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.994 12.683L12.648 24.1894H12.0655C9.3358 24.1894 6.60611 23.2441 4.39795 21.3536L21.1977 4.31622C23.0675 6.55561 23.9996 9.3239 23.994 12.0922V12.6717V12.683Z",
    fill: "#C53437"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 24.1894H12.6482L23.9942 12.683L23.9997 24.1894Z",
    fill: "#9E071E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsistaChat);
export default __webpack_public_path__ + "static/media/asista_chat.024159354a9456d0dd172d99180da3f7.svg";
export { ForwardRef as ReactComponent };